import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { stateCardInfo, StateIconInfo } from './model';
import { OperationsCardStatus } from './operationsCards/OperationsCardStatus';
import { BinaryStates } from '../../state/constants';

type Props = {
  type: BinaryStates;
  loading?: boolean;
  label: string;
};

export const StatusCard = ({ type, loading, label }: Props) => {
  const { t } = useTranslation();
  const iconType: StateIconInfo = useMemo(() => {
    return stateCardInfo[type];
  }, [type]);

  return (
    <OperationsCardStatus loading={loading} type={iconType} label={t(label)} />
  );
};
